// extracted by mini-css-extract-plugin
export default {"main_container":"DashboardBF_main_container__mGOlO","content_area":"DashboardBF_content_area__EW0nq","link":"DashboardBF_link__SS5l6"};